import React from "react";
import { Box, Typography } from "@mui/material";
import MoovsDatePicker from "../../../../components/ui/MoovsDatePicker";
import MoovsTimePicker from "../../../../components/ui/MoovsTimePicker";

type ToDateTimeInputProps = {
  value: any;
  onDateChange: (date: any) => void;
  onTimeChange: (time: any) => void;
  disabled?: boolean;
};

function ToDateTimeInput({
  value,
  onDateChange,
  onTimeChange,
  disabled = false,
}: ToDateTimeInputProps) {
  return (
    <>
      <Typography variant="overline">TO</Typography>
      <Box display="flex" gap={2} mb={3} mt={1}>
        <MoovsDatePicker
          value={value}
          onAccept={onDateChange}
          disabled={disabled}
          renderInputProps={{
            fullWidth: true,
            size: "small",
          }}
        />
        <MoovsTimePicker
          value={value}
          onAccept={onTimeChange}
          disabled={disabled}
          renderInputProps={{
            fullWidth: true,
            size: "small",
          }}
        />
      </Box>
    </>
  );
}

export default ToDateTimeInput;